import { render, staticRenderFns } from "./reservation-dashboard-card.vue?vue&type=template&id=16558184&scoped=true&"
import script from "./reservation-dashboard-card.vue?vue&type=script&lang=js&"
export * from "./reservation-dashboard-card.vue?vue&type=script&lang=js&"
import style0 from "./reservation-dashboard-card.vue?vue&type=style&index=0&id=16558184&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16558184",
  null
  
)

export default component.exports